import { NgModule }       from '@angular/core';
import { RouterModule }   from '@angular/router';
import { AuthGuard }      from './auth.guard';
import { AuthService }    from './auth.service';
import { LoginComponent } from './login.component';
import { LogoutComponent } from './logout.component';

@NgModule({
    imports: [
        RouterModule.forChild([
            { path: 'login', component: LoginComponent },
            { path: 'logout', component: LogoutComponent}
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        AuthGuard,
        AuthService
    ]
})
export class LoginRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/auth/login-routing.module.ts